export enum TabsStyleTypesEnum {
    default = 'default',
    icon = 'icon',
    social = 'social'
}
